var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7125 18.3893L14.5925 14.5093L18.4725 18.3893C18.8625 18.7793 19.4925 18.7793 19.8825 18.3893C20.2725 17.9993 20.2725 17.3693 19.8825 16.9793L15.2925 12.3893C15.1057 12.202 14.852 12.0968 14.5875 12.0968C14.323 12.0968 14.0693 12.202 13.8825 12.3893L9.2925 16.9793C8.9025 17.3693 8.9025 17.9993 9.2925 18.3893C9.6825 18.7693 10.3225 18.7793 10.7125 18.3893Z",
    fill: "#C3CAD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowUp);
export default __webpack_public_path__ + "static/media/keyboard_arrow_up.367b77b522bc9c838b054307bf10a79b.svg";
export { ForwardRef as ReactComponent };